import React, { useMemo } from "react";

import {
    filter, formatDate, getMetricValue, GraphProps,
} from "./base";
import Chart from "./Chart";
import { MetricsDashboardGraphDimensionFormat } from "../../../__generated__/api";

export default function TimeSeries(props: GraphProps) {
    const options = useMemo(() => {
        const dimension = props.graph.dimensions?.firstElement;
        if (!dimension) {
            return {};
        }
        const dateIndex = props.columnIndexMap[dimension.fieldId];

        const dataRows = filter(props.data.rows, props.graph.filters, props.columnIndexMap);

        const rows = dataRows.groupBy(row => {
            const date = new Date(row.values[dateIndex] as string);
            return formatDate(date, dimension.format ?? MetricsDashboardGraphDimensionFormat.YearMonthDay);
        });

        const metrics = props.graph.metrics ?? [];

        const groups: string[][][] = metrics.map(() => []);
        Object.entries(rows).forEach(([date, group]) => {
            metrics.forEach((metric, index) => {
                const metricIndex = props.columnIndexMap[metric.fieldId];
                const value = getMetricValue(group.map(row => row.values[metricIndex]).filterNull(), metric.aggregation);

                return groups[index].push([date, value?.toString() ?? "-"]);
            });
        });

        return {
            tooltip: {
                trigger: "axis",
                formatter(params: {seriesName: string; name: string; value: string[]}[]) {
                    return params.map(param => {
                        const date = new Date(param.value[0]);

                        return `<strong>${param.seriesName}</strong><br />${date.toLocaleDateString()} : ${
                            param.value[1]}`;
                    }).join("<br /><br />");
                },
                axisPointer: {
                    animation: false,
                },
            },
            yAxis: props.graph.metrics?.map(() => ({
                type: "value",
                splitLine: {
                    show: false,
                },
            })),
            xAxis: {
                type: "time",
                splitLine: {
                    show: false,
                },
            },
            legend: {
                left: "2%",
            },
            grid: {
                left: "3%",
                right: "3%",
                bottom: "10%",
                top: "20%",
            },
            dataZoom: [
                {
                    type: "inside",
                    xAxisIndex: 0,
                    minValueSpan: 2,
                },
            ],

            series: props.graph.metrics?.map((metric, index) => ({
                name: metric.label,
                type: "line",
                showSymbol: false,
                data: groups[index],
                yAxisIndex: index,
            })),

        };
    }, [props.data]);

    return (
        <div>
            {props.graph.title && (<strong className="d-block ms-1 text-light">{props.graph.title}</strong>)}

            <Chart options={options} />
        </div>
    );
}
